// extracted by mini-css-extract-plugin
export default {"show":"AnimatedPrice__show___XeADG","hide":"AnimatedPrice__hide___AzDlG"};